import { FC, useEffect, useState } from 'react'
import axios from 'axios'
import { useQuery } from 'react-query'
import { useT } from '../../../../../../../_metronic/i18n/Metronici18n'
import { useAuth } from '../../../../../auth'
import { getMiniaturaEstudoDicom } from '../../../../atendimento/core/_requests'
import { EstudoDicom } from '../../../../atendimento/core/_models'
import { valoresDescricaoEstudo } from './descricaoEstudo'
import styles from './VisualizadorDicom.module.css'

type Props = {
  idAtendimento: number
  estudo: EstudoDicom
}

const DEZ_MINUTOS = 10 * 60 * 1000

const chaveDoErro = (erro: unknown): string => {
  const status = axios.isAxiosError(erro) ? erro.response?.status : undefined
  if (status === 401) return 'exames_imagem.viewer.miniatura_sessao'
  if (status === 403 || status === 404) return 'exames_imagem.viewer.miniatura_indisponivel'
  return 'exames_imagem.viewer.miniatura_erro'
}

export const EstudoDicomMiniatura: FC<Props> = ({ idAtendimento, estudo }) => {
  const { t } = useT()
  const { auth, currentUser } = useAuth()
  const sessaoAtiva = !!auth?.accessToken && !!currentUser
  const uid = estudo.studyInstanceUid
  // staleTime longo: cada GET da miniatura grava MINIATURA na trilha da D4.
  const miniatura = useQuery(
    ['dicom-miniatura', idAtendimento, uid],
    () => getMiniaturaEstudoDicom(idAtendimento, uid),
    { enabled: sessaoAtiva, staleTime: DEZ_MINUTOS, retry: false, refetchOnWindowFocus: false }
  )
  const [url, setUrl] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (!miniatura.data || !sessaoAtiva) return undefined
    const objeto = URL.createObjectURL(miniatura.data)
    setUrl(objeto)
    return () => {
      URL.revokeObjectURL(objeto)
      setUrl(undefined)
    }
  }, [miniatura.data, sessaoAtiva])

  if (!sessaoAtiva) return null

  if (miniatura.isError) {
    return (
      <div className={styles.miniaturaErro}>
        <i className='fas fa-image fs-7 me-1' style={{ color: 'inherit' }} aria-hidden='true' />
        <span>{t(chaveDoErro(miniatura.error))}</span>
      </div>
    )
  }

  if (!url) {
    return (
      <div className={styles.miniatura} aria-busy='true'>
        <span className='visually-hidden'>{t('exames_imagem.viewer.miniatura_carregando')}</span>
      </div>
    )
  }

  return (
    <img
      className={styles.miniatura}
      src={url}
      alt={t('exames_imagem.viewer.miniatura_alt', valoresDescricaoEstudo(estudo, t))}
    />
  )
}
